import { IHttpData } from "sol-request-angular/dist/comunicacao/interfaces/IHttpData";

export class FormFile implements IHttpData {
    private _data;

    get data(): FormData {
        return this._data;
    }
    set data(data: FormData) {
        this._data = data;
    }

    constructor(formData: FormData) {
        this._data = formData;
    }
    
    buildData() {
        return this.data;
    }
    
    buildPathData() {
        throw "Not Implemented";
    }
    
    setHttpHeaderRequest(httpHeaders) {
        return httpHeaders;
    }
}
